import {createReducer} from "@reduxjs/toolkit";
import {createAction} from 'redux-actions';
import reduceReducers from 'reduce-reducers';
import videoPlayerReducer from 'src/shared/video/video_room/player/actions.jsx'
import videoRoomTabsReducer from 'src/shared/video/video_room/widgets/actions.jsx'
import dbReducer from 'src/shared/database_actions.jsx'
import {useSelector} from "react-redux";
import axios from "axios";

export const appendSupportChatSession = createAction("APPEND_SUPPORT_CHAT_SESSION")
export const appendSupportChatMessage = createAction("APPEND_SUPPORT_CHAT_MESSAGE")
export const appendSupportChatMessages = createAction("APPEND_SUPPORT_CHAT_MESSAGES")
export const setSupportChatSessionId = createAction("SET_SUPPORT_CHAT_SESSION_ID")

export const setManagedEvent = createAction("SET_MANAGED_EVENT");
export const setSavedImageHotspotConfigs = createAction("SET_SAVED_IMAGE_HOTSPOT_CONFIGS");
export const addImageHotspotConfig = createAction("ADD_IMAGE_HOTSPOT_CONFIG");
export const abortNewImageHotspotConfigs = createAction("ABORT_NEW_IMAGE_HOTSPOT_CONFIGS")
export const updateImageHotspotConfig = createAction("UPDATE_IMAGE_HOTSPOT_CONFIG")
export const setCurrentImageHotspotId = createAction("SET_CURRENT_IMAGE_HOTSPOT_ID")
export const removeImageHotspot = createAction("REMOVE_IMAGE_HOTSPOT")

export const updateTagOwnerConnections = createAction("UPDATE_TAG_OWNER_CONNECTIONS")
export const updateTagOwnerMediaFileBookmarks = createAction("UPDATE_TAG_OWNER_MEDIA_FILE_BOOKMARKS")
export const setCurrentSongIdentifier = createAction("SET_CURRENT_SONG_IDENTIFIER")
export const setLastAblyEventId = createAction("SET_LAST_ABLY_EVENT_ID")

export const removePushNotification = createAction("REMOVE_PUSH_NOTIFICATION")

// TODO NOT FINISHED CALLS
export const setQuestions = createAction("SET_QUESTIONS");
export const setBetting = createAction("SET_BETTING");
// \TODO NOT FINISHED CALLS

export const setGuestListEntries = createAction("SET_GUEST_LIST_ENTRIES");

export const setAblyConnectionToken = createAction("SET_ABLY_CONNECTION_TOKEN")
export const setHtmlTabTitle = createAction("SET_HTML_TAB_TITLE")
export const setServerTimeDifference = createAction("SET_SERVER_TIME_DIFFERENCE")

// Direct messaging
export const updatedChatMessages = createAction("UPDATE_CHAT_MESSAGES")
export const updateDirectMessagingEnabled = createAction("UPDATE_DIRECT_MESSAGING_ENABLED")
export const setDirectMessageError = createAction("SET_DIRECT_MESSAGE_ERROR")
export const directMessageSending = createAction("DIRECT_MESSAGE_SENDING")
export const directMessageSent = createAction("DIRECT_MESSAGE_SENT")
export const directMessageMarkMessagesRead = createAction("DIRECT_MESSAGE_MARK_MESSAGE_READ")
export const directMessageClearReadMessages = createAction("DIRECT_MESSAGE_CLEAR_READ_MESSAGES")
export const directMessageSetReceiverTagOwner = createAction("DIRECT_MESSAGE_SET_RECEIVER_TAG_OWNER")

export const chatRouletteSetAccessToken = createAction("CABLE_CHAT_ROULETTE_SET_ACCESS_TOKEN")
export const chatRouletteClearAccessToken = createAction("CABLE_CHAT_ROULETTE_SET_CLEAR_ACCESS_TOKEN")
export const chatRouletteMeetingEnded = createAction("CABLE_CHAT_ROULETTE_MEETING_ENDED")
export const chatRouletteSetQueueState = createAction("CABLE_CHAT_ROULETTE_SET_QUEUE_STATE")

export const groupChatSetAccessToken = createAction("CABLE_GROUP_CHAT_SET_ACCESS_TOKEN")
export const groupChatClearAccessToken = createAction("CABLE_GROUP_CHAT_SET_CLEAR_ACCESS_TOKEN")
export const groupChatMeetingEnded = createAction("CABLE_GROUP_CHAT_MEETING_ENDED")
export const groupChatSetQueueState = createAction("CABLE_GROUP_CHAT_SET_QUEUE_STATE")
export const groupChatAddParticipant = createAction("CABLE_GROUP_CHAT_ADD_PARTICIPANT")
export const groupChatRemoveParticipant = createAction("CABLE_GROUP_CHAT_REMOVE_PARTICIPANT")
export const groupChatClearParticipants = createAction("CABLE_GROUP_CHAT_CLEAR_PARTICIPANTS")

export const addVideoConferenceChatMessage = createAction("CABLE_ADD_VIDEO_CONFERENCE_CHAT_MESSAGE")
export const setEyesonReadyState = createAction("CABLE_SET_EYESON_READY_STATE")

export const setBackgroundVideoLoopState = createAction("CABLE_SET_BACKGROUND_VIDEO_LOOP_STATE")
export const setCableGdprConfirmationUpdated = createAction("CABLE_GDPR_CONFIRMATION_UPDATED")

export const setBackgroundVideoLoopCurrentImageMapId = createAction("CABLE_SET_BACKGROUND_VIDEO_LOOP_CURRENT_IMAGE_MAP_ID")

export const setLeadGenerationAccountOrganizationIds = createAction("SET_LEAD_GENERATION_ACCOUNT_ORGANIZATION_IDS")

export const setShowGlobalPopup = createAction("SET_SHOW_GLOBAL_POPUP")

const exhibition_actions = createReducer({}, {
  [setServerTimeDifference]: (state, action) => {
    if (!state.serverTimeDifference && state.serverEpochTime) {
      const clientEpochTime = Math.round((new Date()).getTime() / 1000);
      state.serverTimeDifference = state.serverEpochTime - clientEpochTime;
    } else if (!state.serverEpochTime) {
      console.error("SERVER EPOCH TIME NOT SET!")
    }
  },

  [setHtmlTabTitle]: (state, action) => {
    state.htmlTabTitle = action.payload
  },
  [setAblyConnectionToken]: (state, action) => {
    state.connectionToken = action.payload
  },
  [setGuestListEntries]: (state, action) => {
    state.guestListEntries = action.payload
  },
  ["CABLE_EVENT_CREATED"]: (state, action) => {
    state.events = state.events.filter((scm) => action.payload.id !== scm.id)
    state.events = state.events.concat(action.payload)
  },
  ["CABLE_EVENT_UPDATED"]: (state, action) => {
    state.events = state.events.filter((scm) => action.payload.id !== scm.id)
    state.events = state.events.concat(action.payload)
  },
  ["CABLE_HTML_CONTENT_UPDATED"]: (state, action) => {
    if (state.htmlContents === undefined)
      state.htmlContents = []
    state.htmlContents = state.htmlContents.filter((scm) => action.payload.id !== scm.id)
    state.htmlContents = state.htmlContents.concat(action.payload)
  },
  ["CABLE_VIDEO_ROOM_UPDATED"]: (state, action) => {
    state.videoRooms = state.videoRooms.filter((scm) => action.payload.id !== scm.id)
    state.videoRooms = state.videoRooms.concat(action.payload)
  },
  ["CABLE_TAG_OWNER_UPDATED"]: (state, action) => {
    state.tagOwner = action.payload
  },
  [setLastAblyEventId]: (state, action) => {
    state.lastAblyEventId = action.payload
  },
  [setCurrentSongIdentifier]: (state, action) => {
    state.currentSongIdentifier = action.payload;
  },

  [setBetting]: (state, action) => {
    state.bettings = state.bettings.filter((scm) => action.payload.id !== scm.id)
    state.bettings = state.bettings.concat(action.payload)
  },
  [setQuestions]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((scm) => action.payload.id !== scm.id)
    state.eventQuestions = state.eventQuestions.concat(action.payload)
  },
  [appendSupportChatSession]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    if (action.payload.tag_owner_id === state.tagOwner.id) {
      state.supportChatSessions.push(action.payload);
    }
  },
  [appendSupportChatMessage]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    if (action.payload.tag_owner_id === state.tagOwner.id) {
      state.supportChatMessages.push(action.payload)
    }
  },
  [appendSupportChatMessages]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => action.payload.every(m => scm.id !== m.id))
    state.supportChatMessages = state.supportChatMessages.concat(action.payload.filter(m => m.tag_owner_id === state.tagOwner.id))
  },

  [setCurrentImageHotspotId]: (state, action) => {
    state.setCurrentImageHotspotId = action.payload
  },
  [setSupportChatSessionId]: (state, action) => {
    state.supportChatSessionId = action.payload
  },

  [updateTagOwnerConnections]: (state, action) => {
    state.contactTagOwnerConnections = action.payload
  },
  [updateTagOwnerMediaFileBookmarks]: (state, action) => {
    state.tagOwnerImageHotspotDownloadFileBookmarks = action.payload
  },

  [removePushNotification]: (state, action) => {
    state.push_notifications = state.push_notifications.filter(pushNotification => pushNotification.id !== action.payload)
  },

  [updateDirectMessagingEnabled]: (state, action) => {
    state.directMessaging.isDirectMessagingEnabled = action.payload
  },
  [setDirectMessageError]: (state, action) => {
    state.directMessaging.chatError = action.payload
  },
  [directMessageSending]: (state, action) => {
    state.directMessaging.isSending = true
  },
  [directMessageSent]: (state, action) => {
    state.directMessaging.isSending = false
  },
  [updatedChatMessages]: (state, action) => {
    action.payload.forEach((newMessage) => {
      if (newMessage.receiver_tag_owner_id === state.tagOwner.id || newMessage.sender_tag_owner_id === state.tagOwner.id) {
        state.directMessaging.messages = [
          ...state.directMessaging.messages.filter((message) => newMessage.id !== message.id),
          newMessage
        ]
      }
    })
  },
  [directMessageMarkMessagesRead]: (state, action) => {
    if (state.directMessaging.readMessageIds) {
      state.directMessaging.readMessageIds = [
        ...state.directMessaging.readMessageIds,
        ...action.payload
      ]
    } else {
      state.directMessaging.readMessageIds = action.payload
    }
  },
  [directMessageClearReadMessages]: (state, action) => {
    state.directMessaging.readMessageIds = state.directMessaging.readMessageIds?.filter((id) => action.payload.indexOf(id) === -1)
  },
  [directMessageSetReceiverTagOwner]: (state, action) => {
    state.directMessaging.receiverTagOwner = action.payload
  },
  [chatRouletteSetAccessToken]: (state, action) => {
    state.chatRoulette = {
      ...state.chatRoulette,
      queueState: null,
      access_token: action.payload.access_token
    }
  },
  [chatRouletteSetQueueState]: (state, action) => {
    state.chatRoulette = {
      ...state.chatRoulette,
      queueState: action.payload.queueState
    }
  },
  [chatRouletteClearAccessToken]: (state, action) => {
    state.chatRoulette = {
      ...state.chatRoulette,
      access_token: null
    }
  },
  [chatRouletteMeetingEnded]: (state, action) => {
    state.chatRoulette = {
      ...state.chatRoulette,
      access_token: null,
      queueState: null
    }
  },
  [groupChatSetAccessToken]: (state, action) => {
    state.groupChat = {
      ...state.groupChat,
      queueState: null,
      access_token: action.payload
    }
  },
  [groupChatSetQueueState]: (state, action) => {
    state.groupChat = {
      ...state.groupChat,
      queueState: action.payload.queueState
    }
  },
  [groupChatAddParticipant]: (state, action) => {
    state.groupChat.participants ||= []

    state.groupChat = {
      ...state.groupChat,
      participants: [
        ...state.groupChat.participants,
        action.payload
      ]
    }
  },
  [groupChatRemoveParticipant]: (state, action) => {
    state.groupChat.participants ||= []

    state.groupChat = {
      ...state.groupChat,
      participants: state.groupChat.participants.filter(participant => participant.id !== action.payload?.id)
    }
  },
  [groupChatClearParticipants]: (state, action) => {
    state.groupChat = {
      ...state.groupChat,
      participants: []
    }
  },
  [groupChatClearAccessToken]: (state, action) => {
    state.groupChat = {
      ...state.groupChat,
      access_token: null
    }
  },
  [groupChatMeetingEnded]: (state, action) => {
    state.groupChat = {
      ...state.groupChat,
      access_token: null,
      queueState: null
    }
  },
  [addVideoConferenceChatMessage]: (state, action) => {
    state.eyeson ||= {}
    state.eyeson.chatMessages ||= []
    state.eyeson.chatMessages = [
      ...state.eyeson.chatMessages,
      action.payload
    ]
  },
  [setEyesonReadyState]: (state, action) => {
    state.eyeson ||= {}
    state.eyeson.isReady = action.payload
  },
  [setBackgroundVideoLoopState]: (state, action) => {
    state.backgroundVideoLoop = {
      ...state.backgroundVideoLoop,
      state: action.payload
    }
  },
  [setBackgroundVideoLoopCurrentImageMapId]: (state, action) => {
    state.backgroundVideoLoop = {
      ...state.backgroundVideoLoop,
      currentImageMapId: action.payload
    }
  },
  [setShowGlobalPopup]: (state, action) => {
    state.directMessaging.showGlobalPopup = action.payload
  },
  [setLeadGenerationAccountOrganizationIds]: (state, action) => {
    state.leadGenerationAccountOrganizationIds = action.payload

  },
  ["CABLE_CHAT_MESSAGE_CREATED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id),
        action.payload
      ]
    }
  },
  ["CABLE_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id),
        action.payload
      ]
    }
  },
  ["CABLE_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    if (!action.payload.video_room_id && (action.payload.receiver_tag_owner_id === state.tagOwner.id || action.payload.sender_tag_owner_id === state.tagOwner.id)) {
      state.directMessaging.messages = [
        ...state.directMessaging.messages.filter((message) => action.payload.id !== message.id)
      ]
    }
  },
  ["CABLE_GDPR_CONFIRMATION_CREATED"]: (state, action) => {
    state.gdprConfirmation = action.payload
  },
  ["CABLE_GDPR_CONFIRMATION_UPDATED"]: (state, action) => {
    state.gdprConfirmation = action.payload
  },
  ["CABLE_PUSH_MESSAGE_NOTIFICATION"]: (state, action) => {
    state.push_notifications.push(action.payload)
  },

  ["CABLE_BET_UPDATED"]: (state, action) => {
    state.bets[action.payload.id] = action.payload
  },
  ["CABLE_BETTING_CREATED"]: (state, action) => {
    state.bettings.push(action.payload)
  },
  ["CABLE_BETTING_DESTROYED"]: (state, action) => {
    console.warn("bettings", state.bettings)
    state.bettings.splice(state.bettings.findIndex((betting) => betting.id == action.payload.id), 1)
    console.warn("bettings", state.bettings)
  },

  ["CABLE_ACCOUNT_ORGANIZATION_CREATED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
    state.accountOrganizations.push(action.payload)
  },
  ["CABLE_ACCOUNT_ORGANIZATION_UPDATED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
    state.accountOrganizations.push(action.payload)
  },
  ["CABLE_ACCOUNT_ORGANIZATION_DESTROYED"]: (state, action) => {
    state.accountOrganizations = state.accountOrganizations.filter((ao) => ao.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_SESSION_CREATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_UPDATED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
    state.supportChatSessions.push(action.payload);
  },
  ["CABLE_SUPPORT_CHAT_SESSION_DESTROYED"]: (state, action) => {
    state.supportChatSessions = state.supportChatSessions.filter((scs) => scs.id !== action.payload.id)
  },

  ["CABLE_SUPPORT_CHAT_MESSAGE_CREATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
    state.supportChatMessages.push(action.payload)
  },
  ["CABLE_SUPPORT_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    state.supportChatMessages = state.supportChatMessages.filter((scm) => scm.id !== action.payload.id)
  },

  ["CABLE_IMAGE_MAP_CONFIG_CREATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
    state.imageMapConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_CONFIG_UPDATED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
    state.imageMapConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_CONFIG_DESTROYED"]: (state, action) => {
    state.imageMapConfigs = state.imageMapConfigs.filter((imc) => imc.id !== action.payload.id)
  },

  ["CABLE_IMAGE_MAP_CREATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
    state.imageMaps.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_UPDATED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
    state.imageMaps.push(action.payload)
  },
  ["CABLE_IMAGE_MAP_DESTROYED"]: (state, action) => {
    state.imageMaps = state.imageMaps.filter((im) => im.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_CONFIG_CREATED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
    state.imageHotspotConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_UPDATED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
    state.imageHotspotConfigs.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_CONFIG_DESTROYED"]: (state, action) => {
    state.imageHotspotConfigs = state.imageHotspotConfigs.filter((ihc) => ihc.id !== action.payload.id)
  },
  ["CABLE_EVENT_QUESTION_CREATED"]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((scm) => action.payload.id !== scm.id)
    state.eventQuestions = state.eventQuestions.concat(action.payload)
  },
  ["CABLE_EVENT_QUESTION_UPDATED"]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((im) => im.id !== action.payload.id)
    state.eventQuestions.push(action.payload)
  },
  ["CABLE_EVENT_QUESTION_DESTROYED"]: (state, action) => {
    state.eventQuestions = state.eventQuestions.filter((im) => im.id !== action.payload.id)
  },
  ["CABLE_IMAGE_HOTSPOT_CREATED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
    state.imageHotspots.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_UPDATED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
    state.imageHotspots.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DESTROYED"]: (state, action) => {
    state.imageHotspots = state.imageHotspots.filter((ih) => ih.id !== action.payload.id)
  },

  ["CABLE_MEDIA_FILES_CREATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles?.filter((mf) => !action.payload.some(pmf => mf.id === pmf.id)) || []
    state.mediaFiles.push(...action.payload)
  },
  ["CABLE_MEDIA_FILE_CREATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles?.filter((mf) => mf.id !== action.payload.id) || []
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_UPDATED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles?.filter((mf) => mf.id !== action.payload.id) || []
    state.mediaFiles.push(action.payload)
  },
  ["CABLE_MEDIA_FILE_DESTROYED"]: (state, action) => {
    state.mediaFiles = state.mediaFiles?.filter((mf) => mf.id !== action.payload.id) || []
  },

  ["CABLE_TAG_OWNER_IMAGES_CREATED"]: (state, action) => {
    state.tagOwnerImages = state.tagOwnerImages?.filter((mf) => !action.payload.some(pmf => mf.id === pmf.id)) || []
    state.tagOwnerImages.push(...action.payload)
  },
  ["CABLE_TAG_OWNER_IMAGE_CREATED"]: (state, action) => {
    state.tagOwnerImages = state.tagOwnerImages?.filter((mf) => mf.id !== action.payload.id) || []
    state.tagOwnerImages.push(action.payload)
  },
  ["CABLE_TAG_OWNER_IMAGE_UPDATED"]: (state, action) => {
    state.tagOwnerImages = state.tagOwnerImages?.filter((mf) => mf.id !== action.payload.id) || []
    state.tagOwnerImages.push(action.payload)
  },
  ["CABLE_TAG_OWNER_IMAGE_DESTROYED"]: (state, action) => {
    state.tagOwnerImages = state.tagOwnerImages?.filter((mf) => mf.id !== action.payload.id) || []
  },

  ["CABLE_STORED_PHOTOS_CREATED"]: (state, action) => {
    state.storedPhoto = state.storedPhoto?.filter((mf) => !action.payload.some(pmf => mf.id === pmf.id)) || []
    state.storedPhoto.push(...action.payload)
  },
  ["CABLE_STORED_PHOTO_CREATED"]: (state, action) => {
    state.storedPhoto = state.storedPhoto?.filter((mf) => mf.id !== action.payload.id) || []
    state.storedPhoto.push(action.payload)
  },
  ["CABLE_STORED_PHOTO_UPDATED"]: (state, action) => {
    state.storedPhoto = state.storedPhoto?.filter((mf) => mf.id !== action.payload.id) || []
    state.storedPhoto.push(action.payload)
  },
  ["CABLE_STORED_PHOTO_DESTROYED"]: (state, action) => {
    state.storedPhoto = state.storedPhoto?.filter((mf) => mf.id !== action.payload.id) || []
  },

  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_CREATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotDownloadFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_DOWNLOAD_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotDownloadFiles = state.imageHotspotDownloadFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_CREATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_UPDATED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotPdfFiles.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_PDF_FILE_DESTROYED"]: (state, action) => {
    state.imageHotspotPdfFiles = state.imageHotspotPdfFiles.filter((mf) => mf.id !== action.payload.id)
  },

  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_CREATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_UPDATED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
    state.imageHotspotSlideshowImages.push(action.payload)
  },
  ["CABLE_IMAGE_HOTSPOT_SLIDESHOW_IMAGE_DESTROYED"]: (state, action) => {
    state.imageHotspotSlideshowImages = state.imageHotspotSlideshowImages.filter((mf) => mf.id !== action.payload.id)
  }
});

export default reduceReducers({}, exhibition_actions, videoPlayerReducer, dbReducer, videoRoomTabsReducer);
// export default reduceReducers({}, exhibition_actions, videoPlayerReducer);

